import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { run } from './run.js';
import { hasSavedInteractionHandle } from './transactionMeta.js';
import { startTransaction } from './startTransaction.js';
import AuthSdkError from '../errors/AuthSdkError.js';
import '../errors/WWWAuthError.js';
import { IdxFeature } from './types/api.js';
function unlockAccount(_x) {
  return _unlockAccount.apply(this, arguments);
}
function _unlockAccount() {
  _unlockAccount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(authClient) {
    var options,
      _yield$startTransacti,
      enabledFeatures,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          options.flow = 'unlockAccount';
          if (hasSavedInteractionHandle(authClient)) {
            _context.next = 9;
            break;
          }
          _context.next = 5;
          return startTransaction(authClient, Object.assign(Object.assign({}, options), {
            autoRemediate: false
          }));
        case 5:
          _yield$startTransacti = _context.sent;
          enabledFeatures = _yield$startTransacti.enabledFeatures;
          if (!(enabledFeatures && !enabledFeatures.includes(IdxFeature.ACCOUNT_UNLOCK))) {
            _context.next = 9;
            break;
          }
          throw new AuthSdkError('Self Service Account Unlock is not supported based on your current org configuration.');
        case 9:
          return _context.abrupt("return", run(authClient, Object.assign({}, options)));
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _unlockAccount.apply(this, arguments);
}
export { unlockAccount };